"use strict";

const startCustomSelectHandlers = () => {
    if (window.__algarCustomSelectHandlersBound) {
        return;
    }

    window.__algarCustomSelectHandlersBound = true;

    const isComplementLockedFromViability = ($fromEl) => $fromEl.closest(".js-complement-from-viability-locked").length > 0;

    $(document).on("click", ".js-select .selected-option", function () {
        if (isComplementLockedFromViability($(this))) {
            return;
        }

        const $selectOptions = $(this).siblings(".select-options");

        $selectOptions.toggle();
        $(this).siblings("i.icon-custom-select-arrow").toggleClass("up");
    });

    $(document).on("click", ".js-select .icon-arrow-down", function () {
        if (isComplementLockedFromViability($(this))) {
            return;
        }

        $(this).siblings(".select-options").toggle();
    });

    $(document).on("click", ".js-select .icon-custom-select-arrow", function () {
        if (isComplementLockedFromViability($(this))) {
            return;
        }

        $(this).siblings(".select-options").toggle();
        $(this).toggleClass("up");
    });

    $(document).on("click", ".js-select .icon-close", function () {
        const $closeBtn               = $(this);

        if (isComplementLockedFromViability($closeBtn)) {
            return;
        }

        const $jsSelect               = $closeBtn.closest(".js-select");
        const $selectedOpt            = $closeBtn.siblings(".selected-option");
        const $customSelectCleanEvent = $.Event("customSelectClean");

        $selectedOpt.text("");
        $closeBtn.hide();
        $closeBtn.siblings("i.icon-arrow-down").show();
        $closeBtn.siblings(".select-label").removeClass("float");

        if ($jsSelect.hasClass("js-viability-complement-widget")) {
            const $form = $jsSelect.closest("form, .js-verify-viability");

            $form.find(".js-viability-complement-code").val("");
            $form.find(".js-viability-complement-type-id-field").val("");
        }

        if ($jsSelect.hasClass("js-viability-complement2-widget")) {
            const $form = $jsSelect.closest("form, .js-verify-viability");

            $form.find(".js-viability-complement2-code").val("");
            $form.find(".js-viability-complement2-type-id-field").val("");
        }

        $jsSelect.trigger($customSelectCleanEvent);
        $selectedOpt.trigger($customSelectCleanEvent);
    });

    $(document).on("click", ".js-select .select-options li", function () {
        const $this               = $(this);

        if (!$this.is("[hidden-selectable=true]") && $this.is(":hidden")) {
            return;
        }

        if (isComplementLockedFromViability($this)) {
            return;
        }

        const $parent                  = $this.parent();
        const $jsSelect                = $parent.closest(".js-select");
        const selectedOption           = $this.text();
        const $customSelectChangeEvent = $.Event("customSelectChange");

        $parent.siblings(".selected-option").text(selectedOption);
        $parent.siblings(".select-label").addClass("float");
        $parent.siblings("i.icon-close").show();
        $parent.siblings("i.icon-arrow-down").hide();
        $parent.hide();
        $parent.siblings("i.icon-custom-select-arrow").removeClass("up");

        if ($jsSelect.hasClass("js-viability-complement-widget")) {
            const code   = $this.data("complement-code") || $this.attr("value") || "";
            const typeId = $this.data("complement-type-id") || "";
            const $scope = $jsSelect.closest("form, .js-verify-viability");

            $scope.find(".js-viability-complement-code").val(code);
            $scope.find(".js-viability-complement-type-id-field").val(typeId);
        }

        if ($jsSelect.hasClass("js-viability-complement2-widget")) {
            const code   = $this.data("complement-code") || $this.attr("value") || "";
            const typeId = $this.data("complement-type-id") || "";
            const $scope = $jsSelect.closest("form, .js-verify-viability");

            $scope.find(".js-viability-complement2-code").val(code);
            $scope.find(".js-viability-complement2-type-id-field").val(typeId);
        }

        $this.trigger($customSelectChangeEvent);
        $parent.siblings(".selected-option").trigger($customSelectChangeEvent, { targetElem: $this });
    });

    $(document).on("click", function (event) {
        if (!$(event.target).closest(".js-select").length) {
            $(".js-select .select-options").hide();
            $(".js-select i.icon-custom-select-arrow").removeClass("up");
        }
    });
};

const startCustomSearchSelectHandlers = () => {
    if (window.__algarCustomSearchSelectHandlersBound) {
        return;
    }

    window.__algarCustomSearchSelectHandlersBound = true;

    let $selected = null;

    const filterOptions = ($input) => {
        const value          = $input.val().toLowerCase();
        const $selectOptions = $input.siblings(".select-options");
        const $options       = $selectOptions.find("li");
        const $noResults     = $selectOptions.find(".no-results");

        $options.filter(function () {
            $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
        });

        if ($options.is(":visible")) {
            $noResults.hide();
        } else {
            $noResults.show();
        }
    };

    $(document).on("focus", ".js-search-select input.selected-option", function () {
        const $selectOptions = $(this).siblings(".select-options");

        $selectOptions.show();
        filterOptions($(this));
    });

    $(document).on("click", ".js-search-select .select-options li", function () {
        const selectedOption = $(this).text();
        const $input         = $(this).parent().siblings("input.selected-option");

        $input.val(selectedOption);
        $input.trigger("change");
        $(this).addClass("active").siblings().removeClass("active");
        $(this).parent().hide();
        $(this).parent().siblings("i.icon-close").show();
        $(this).parent().siblings("i.icon-arrow-down").hide();
        $(this).parent().siblings("i.icon-custom-select-arrow").removeClass("up");
    });

    $(document).on("click", ".js-search-select i.icon-close", function () {
        const $input         = $(this).siblings("input.selected-option");
        const $selectOptions = $(this).siblings(".select-options");

        $input.val("");
        $input.trigger("change");
        $selectOptions.find("li").removeClass("active");
        $(this).hide();
        $(this).siblings("i.icon-arrow-down").show();
        $selectOptions.hide();
    });

    $(document).on("click", ".js-search-select i.icon-arrow-down", function () {
        const $selectOptions = $(this).siblings(".select-options");

        $selectOptions.show();
    });

    $(document).on("keyup", ".js-search-select input.selected-option", function (e) {
        const value          = $(this).val().toLowerCase();
        const $selectOptions = $(this).siblings(".select-options");
        const $options       = $selectOptions.find("li");
        const $iconClose     = $(this).siblings("i.icon-close");
        const $iconArrowDown = $(this).siblings("i.icon-arrow-down");

        $selectOptions.show();

        if (e.keyCode !== 38 && e.keyCode !== 40) {
            filterOptions($(this));
        }

        if (value === "" && $iconClose.is(":visible")) {
            $iconClose.hide();
            $iconArrowDown.show();
        }

        if (value !== "" && $iconArrowDown.is(":visible")) {
            $iconArrowDown.hide();
            $iconClose.show();
        }

        if (e.keyCode === 38) {
            if ($selected === null) {
                $selected = $options.last();
            } else {
                $selected.removeClass("active");
                $selected = $selected.prevAll(":visible").first();

                if ($selected.length === 0) {
                    $selected = $options.last();
                }
            }

            $selectOptions.scrollTop($selected.offset().top - $selectOptions.offset().top + $selectOptions.scrollTop() - 10);
            $selected.addClass("active");
            $(this).val($selected.text());
        } else if (e.keyCode === 40) {
            if ($selected === null) {
                $selected = $options.first();
            } else {
                $selected.removeClass("active");
                $selected = $selected.nextAll(":visible").first();

                if ($selected.length === 0) {
                    $selected = $options.first();
                }
            }

            $selectOptions.scrollTop($selected.offset().top - $selectOptions.offset().top + $selectOptions.scrollTop() - 10);
            $selected.addClass("active");
            $(this).val($selected.text());
        }

        if (e.keyCode === 13) {
            $selected = $options.filter(".active");
            $(this).val($selected.text());
            $(this).siblings(".select-options").hide();
        }
    });

    // hide select options on click outside
    $(document).on("click", function (event) {
        if (!$(event.target).closest(".js-search-select").length) {
            $(".js-search-select .select-options").hide();
        }
    });
};

const initializeSelectScripts = () => {
    startCustomSelectHandlers();
    startCustomSearchSelectHandlers();
};

export default initializeSelectScripts;
